import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "components/app/dialog/dialog";

import { Button } from "components/ui/button";
import { ScrollArea, ScrollBar } from "components/ui/scroll-area";
import { Plus, Trash2, X } from "lucide-react";
import { useEffect, useState } from "react";
import { AppLog } from "services";
import { useAppSelector } from "store/store";
import { RequestApi, RouteApi, StatusMsg } from "utils";
import { Loader } from "lucide-react";
import { useLocation } from "react-router-dom";
// import DailogAddPrinter from "./DailogAddPrinter";
import appStore from "store/appStore";
import { ShimmerDialogEditCategories } from "components/app/shrimmer/Shrimmer";
import TextInput from "components/app/function/TextInput";
import { Snackbar } from "components";
import DailogAddPrinter from "pages/business-suite/dialog/DailogAddPrinter";

type GroupedCategories = {
  [category: string]: string[];
};

interface DialogProps {
  onUploadSuccess: ({ res, name }: { res: any; name: string }) => void;
  editItemCategories: any;
  itemPrinter: any;
  setItemPrinter: any;
  setEditItemCategories: any;
  isDialogOpenEditCategoies: boolean;
  setIsDialogOpenEditCategoies: (value: boolean) => void;
  defaultDataCategories: boolean;
}

export default function DailogEditAndAddCategoriesGroup({
  onUploadSuccess,
  editItemCategories,
  setEditItemCategories,
  isDialogOpenEditCategoies,
  setIsDialogOpenEditCategoies,
  defaultDataCategories,
  itemPrinter,
  setItemPrinter,
}: DialogProps) {
  const [isDailogAddPrinter, setIsDailogAddPrinter] = useState<boolean>(false);
  const { showDialogConfirm } = appStore();
  const [loadingFetchCategoies, setLoadingFetchCategoies] = useState<boolean>(false);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const shopId = searchParams.get("id");
  const [discription, setDiscription] = useState<string>("");
  const [loadingSubmit, setLoadingSubmit] = useState<boolean>(false);
  const [loadingSubmitDelete, setLoadingSubmitDelete] = useState<boolean>(false);
  const { token } = useAppSelector((state) => state.auth);
  const [groups, setGroups] = useState<any>([]);
  const [selectedCodes, setSelectedCodes] = useState<string[]>([]);

  const [selectedPrinters, setSelectedPrinters] = useState<string[]>([]); // Store multiple selected printers
  const selectedPrinter = selectedPrinters.join("|");
  const selectedCodesString = selectedCodes.join("|");
  console.log(selectedCodes, "code");

  const clearData = () => {
    setDiscription("");
    setSelectedCodes([]);
    setSelectedPrinters([]);
  };

  const fetchCategory = async () => {
    setLoadingFetchCategoies(true);
    try {
      let url: string = "";
      setLoadingSubmit(true);
      url = RouteApi.getCategory;
      url += `token=${token}`;
      await RequestApi(url)
        .then((responses) => {
          if (responses.status === "success") {
            setGroups(responses["groups"]);
            setLoadingFetchCategoies(false);
          } else {
          }
        })
        .catch((err) => {
          setLoadingFetchCategoies(false);
        });
      setLoadingSubmit(false);
    } catch (error) {
      AppLog.show({
        message: `[fetchCategory]`,
        status: StatusMsg.error,
        error,
      });
      setLoadingSubmit(false);
    }
  };
  const onSubmitCategroies = async () => {
    try {
      let url: string = "";
      setLoadingSubmit(true);
      url = `${editItemCategories ? RouteApi.submitUpdateShopProductGroup : RouteApi.submitInsertShopProductGroup}token=${token}`;

      const data = {
        shop_id: shopId,
        local_description: discription,
        categories: selectedCodesString,
        product_group_id: editItemCategories?.product_group_id ?? "",
        printer_ids: selectedPrinter,
      };

      await RequestApi(url, { data })
        .then((responses) => {
          if (responses.status === "success") {
            // clearData();
            onUploadSuccess({
              res: responses.user_shop_product_group,
              name: "editOrAdd",
            });
            setIsDialogOpenEditCategoies(false);
          } else {
          }
          setLoadingSubmit(false);
        })
        .catch((err) => {});
      setLoadingSubmit(false);
    } catch (error) {
      AppLog.show({
        message: `[onSubmitCategroies]`,
        status: StatusMsg.error,
        error,
      });
      setLoadingSubmit(false);
    }
  };

  const onSubmitDeleteCartegories = async () => {
    try {
      let url: string = "";
      setLoadingSubmitDelete(true);
      url = RouteApi.submitDeleteShopProductGroup;
      url += `token=${token}`;
      const data = {
        shop_id: shopId,
        product_group_id: editItemCategories.product_group_id,
      };
      await RequestApi(url, { data })
        .then((responses) => {
          if (responses.status === "success") {
            onUploadSuccess({
              res: responses.user_shop_product_group,
              name: "delete",
            });
            setIsDialogOpenEditCategoies(false);
          } else {
            Snackbar({
              message: responses.msg,
              status: StatusMsg.warning,
            });
          }
          setLoadingSubmitDelete(false);
        })
        .catch((err) => {});
      setLoadingSubmitDelete(false);
    } catch (error) {
      AppLog.show({
        message: `[onSubmitDeleteCartegories]`,
        status: StatusMsg.error,
        error,
      });
      setLoadingSubmitDelete(false);
    }
  };

  const onSubmitDeletePrinter = async (id: any) => {
    try {
      let url: string = "";

      url = RouteApi.submitDeleteShopPrinter;
      url += `token=${token}`;
      const data = {
        shop_id: shopId,
        // product_group_id: editItemCategories.product_group_id,
        printer_id: id,
      };
      await RequestApi(url, { data })
        .then((responses) => {
          if (responses.user_shop_printer) {
            setItemPrinter((prevItemGroups: any) => {
              const printerData = responses.user_shop_printer;

              // Remove the deleted printer by filtering it out
              const updatedData = (prevItemGroups || []).filter((item: any) => item.id !== printerData.id);

              return updatedData; // Return updated list without deleted item
            });
          } else {
          }
        })
        .catch((err) => {});
      setLoadingSubmitDelete(false);
    } catch (error) {
      AppLog.show({
        message: `[onSubmitDeletePrinter]`,
        status: StatusMsg.error,
        error,
      });
      setLoadingSubmitDelete(false);
    }
  };
  useEffect(() => {
    fetchCategory();
  }, []); // Run on mount

  useEffect(() => {
    if (defaultDataCategories !== true) {
      if (editItemCategories?.local_description) {
        setDiscription(editItemCategories?.local_description);
      }
    } else {
      setDiscription("");
      setSelectedCodes([]);
      setSelectedPrinters([]);
    }

    if (editItemCategories?.category) {
      setSelectedCodes(editItemCategories?.category.split("|"));
    }
    if (editItemCategories?.kitchen) {
      setSelectedPrinters(editItemCategories?.kitchen.split("|"));
    }
  }, [editItemCategories, defaultDataCategories, isDialogOpenEditCategoies]);

  const groupedCategories: GroupedCategories = groups.reduce((acc: any, item: any) => {
    if (!acc[item.category]) {
      acc[item.category] = [];
    }
    acc[item.category].push(item.code);
    return acc;
  }, {});
  const handleClick = (code: string) => {
    setSelectedCodes(
      (prevCodes) =>
        prevCodes.includes(code)
          ? prevCodes.filter((c) => c !== code) // Remove code if selected
          : [...prevCodes, code] // Add code if not selected
    );
  };

  const togglePrinterSelection = (printerId: string) => {
    setSelectedPrinters(
      (prevSelected) =>
        prevSelected.includes(printerId)
          ? prevSelected.filter((id) => id !== printerId) // Remove if already selected
          : [...prevSelected, printerId] // Add if not selected
    );
  };

  return (
    <>
      <Dialog open={isDialogOpenEditCategoies}>
        <DialogContent isShowBtnXClose={false} className="max-w-[800px] h-[calc(100vh-80px)]  custom-dialog-class flex flex-col justify-between">
          {loadingSubmit && <div className="bg-black/50 flex items-center justify-center w-full h-[calc(100vh-80px)] absolute top-0 left-0 z-10"></div>}
          {loadingSubmitDelete && <div className="bg-black/50 flex items-center justify-center w-full h-[calc(100vh-80px)] absolute top-0 left-0 z-10"></div>}

          <DialogHeader>
            <DialogTitle>{editItemCategories ? "Edit Group" : "Add New Group"}</DialogTitle>
            <DialogDescription>
              {editItemCategories
                ? `  Input group description and choose the category, click "Save" when
            you finished.`
                : `  Input group description and choose the category, click "Save" when
            you finished.`}
            </DialogDescription>
            <div
              className="absolute flex items-center justify-center right-4 top-1 z-40 cursor-pointer rounded-full bg-gray-200 dark:bg-accent w-[28px] h-[28px]"
              onClick={() => {
                // clearData();
                setIsDialogOpenEditCategoies(false);
                setSelectedPrinters([]);
              }}
            >
              <X />
            </div>
          </DialogHeader>
          <ScrollArea className="mt-2 w-full gap-3 pr-[20px]">
            {loadingFetchCategoies ? (
              <>
                <ShimmerDialogEditCategories />
              </>
            ) : (
              <>
                <div className="flex flex-col h-full">
                  <div className="sticky top-0 left-0 bg-white dark:bg-[#020817] px-1">
                    <div>
                      <label htmlFor="local_description" className="block mb-2 text-sm font-medium ">
                        Description
                      </label>
                      <TextInput value={discription} onChange={(e) => setDiscription(e.target.value)} placeholder="" />
                    </div>
                  </div>
                  <h1 className="font-semibold mt-5 px-1">Print to Kitchen or Bar Counter (Food and Beverage)</h1>

                  <div className="w-full grid grid-cols-4 gap-2 mt-2">
                    {itemPrinter?.map((group: any) => (
                      <button
                        onClick={() => {
                          togglePrinterSelection(group?.printer_id);
                        }}
                        key={group?.id}
                        className={` py-2 border border-gray-300  transition-opacity rounded-lg flex items-center justify-between pe-2 ps-3 group ${
                          selectedPrinters.includes(group?.printer_id) ? "bg-primary text-white border-transparent" : "dark:bg-transparent "
                        }`}
                      >
                        {group?.local_description ?? "No Description"}
                        <p></p>
                        <Trash2
                          onClick={(event) => {
                            event.stopPropagation();
                            showDialogConfirm({
                              titileButtonSubmit: "Yes, Delete",
                              titileButtonCancel: "No, Cancel",
                              title: "Delete",
                              message: "Do you want to delete?",
                              onSubmit() {
                                onSubmitDeletePrinter(group?.printer_id);
                              },
                            });
                          }}
                          className=" text-red-500 opacity-0 group-hover:opacity-100 transition-opacity w-5 h-5"
                        />
                      </button>
                    ))}
                    <label
                      onClick={() => setIsDailogAddPrinter(true)}
                      htmlFor=""
                      className={`font-semibold me-1 rounded-full cursor-pointer w-10 h-10 flex items-center justify-center text-md border border-gray-300 
                        `}
                    >
                      <Plus className="font-semibold text-xl" />
                    </label>
                  </div>

                  <h1 className="font-semibold mt-5 px-1">Choose Categories</h1>
                  <div className=" flex ga flex-wrap px-1">
                    {Object.entries(groupedCategories).map(([category, codes]) => (
                      <div key={category}>
                        <h1 className="font-semibold mt-2">{category}</h1>
                        <div className="mt-2 flex gap-2 flex-wrap">
                          {codes.map((code, index) => (
                            <button
                              key={index}
                              onClick={() => {
                                handleClick(code);
                              }}
                              className={`px-4 py-2 rounded-lg border border-gray-300 ${
                                selectedCodes.includes(code) ? "bg-primary text-white border-transparent " : "dark:bg-transparent "
                              }`}
                            >
                              {code}
                            </button>
                          ))}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </>
            )}
            <ScrollBar orientation="vertical" />
          </ScrollArea>
          <DialogFooter className=" flex justify-between gap-3">
            {editItemCategories ? (
              <>
                <Button
                  onClick={() =>
                    showDialogConfirm({
                      title: "Delete",
                      message: "Do you want to delete ?",
                      onSubmit() {
                        onSubmitDeleteCartegories();
                      },
                    })
                  }
                  className="w-full text-white mt-3 bg-red-600 hover:bg-red-500 outline-none border-0 focus:border-yellow-300"
                >
                  {loadingSubmitDelete ? <Loader className="animate-spin" /> : "Delete"}
                </Button>

                <Button onClick={onSubmitCategroies} className="w-full text-white mt-3 bg-blue-600 hover:bg-blue-500 outline-none border-none">
                  {loadingSubmit ? <Loader className="animate-spin" /> : "Save"}
                </Button>
              </>
            ) : (
              <Button onClick={onSubmitCategroies} className="w-full text-white mt-3 bg-blue-600 hover:bg-blue-500">
                {loadingSubmit ? <Loader className="animate-spin" /> : "Save"}
              </Button>
            )}
          </DialogFooter>
        </DialogContent>
      </Dialog>
      <DailogAddPrinter isDailogAddPrinter={isDailogAddPrinter} setIsDailogAddPrinter={setIsDailogAddPrinter} setItemPrinter={setItemPrinter} />
    </>
  );
}
